import { StarIcon } from "@heroicons/react/24/solid";
import { StarIcon as StarIconOutline } from "@heroicons/react/24/outline";
import Modal from "./Modal";
import Button from "./Button";

/**
 * "Would you recommend X?" — the five-star picker every card opens.
 *
 * Post, Event, Tool and Support cards each carried their own copy of this markup, so
 * a wording or layout fix had to be made four times or it silently applied to three
 * card types out of four.
 */
export default function RatingModal({
  open,
  onClose,
  title,
  value,
  onChange,
  onSubmit,
}: {
  open: boolean;
  onClose: (show: boolean) => void;
  /** Name of the thing being rated. */
  title: string;
  /** Stars currently picked, 0 when none. */
  value: number;
  onChange: (value: number) => void;
  onSubmit: (e: any) => void;
}) {
  return (
    <Modal
      show={open}
      setShow={onClose}
      confirmText="Submit"
      cancelText="Cancel"
      confirmHandler={() => { }}
      showActionButtons={false}
      showTriggerButton={false}
    >
      <div className="overflow-auto px-1">
        <div className="text-center">
          <div className="p-8 grid grid-cols-1 gap-y-4 relative text-left">

            {/* Images */}
            <img
              src="/img/graphics/bubbles/bubble-left-green.svg"
              alt="Bubble"
              className="absolute w-20 object-cover top-8 right-0 z-100"
            />
            <img
              src="/img/graphics/bubbles/bubble-top-orange.svg"
              alt="Bubble"
              className="absolute w-28 top-0 right-12 z-100"
            />

            <p className="text-black text-base">Would you recommend:</p>
            <p className="text-black text-base font-semibold line-clamp-2 overflow-hidden text-ellipsis break-words">{title}</p>

            <div className="flex gap-x-1">
              {[...Array(5)].map((_, index) => (
                index < value ? (
                  <StarIcon
                    key={index}
                    className={`h-8 w-8 text-yellow cursor-pointer`}
                    onClick={() => onChange(index + 1)}
                  />
                ) : (
                  <StarIconOutline
                    key={index}
                    className={`h-8 w-8 cursor-pointer text-yellow`}
                    onClick={() => onChange(index + 1)}
                  />
                )
              ))}
            </div>

            <p className="text-black text-base">Ratings really help our community to find what they need. Thanks so much!</p>

            {/* Submit button */}
            <Button
              bgColour="dark-blue"
              borderColour="dark-blue"
              rounded="md"
              onClick={onSubmit}
            >
              <span className="text-white">Submit</span>
            </Button>

          </div>
        </div>
      </div>
    </Modal>
  );
}
